import dynamic from 'next/dynamic'

export const About = {
    Hero: dynamic(() => import('./Hero')),
    // Introduction: dynamic(() => import('./Introduction')),
    Loans: dynamic(() => import('./Loans')),
    Features: dynamic(() => import('./Features')),
    Products: dynamic(() => import('./Products')),
}
